import { render, staticRenderFns } from "./visit-score-table.vue?vue&type=template&id=f9531822&scoped=true&"
import script from "./visit-score-table.vue?vue&type=script&lang=js&"
export * from "./visit-score-table.vue?vue&type=script&lang=js&"
import style0 from "./visit-score-table.vue?vue&type=style&index=0&id=f9531822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9531822",
  null
  
)

export default component.exports